
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminLayout from "./layouts/Admin/Admin.js";
import RTLLayout from "./layouts/RTL/RTL.js";
import Post from "./views/post.js";

import "./assets/scss/black-dashboard-react.scss";
import "./assets/demo/demo.css";
import "./assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";


import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    typography: {
        fontFamily: "Hammersmith One",
    },
    overrides: {
        MuiTypography: {
            body2: {
                fontFamily: "Hammersmith One",
            },
            subheading: {
                fontFamily: "Hammersmith One",
            },
        },
        MuiStepIcon: {
            root: {
                color: '#7d7d7d', // or 'rgba(0, 0, 0, 1)'
                '&$active': {
                    color: '#1d8cf8',
                },
                '&$completed': {
                    color: '#7d7d7d',
                },
            },
        },
    }
});

ReactDOM.render(
    <ThemeProvider theme={theme}>
    <ThemeContextWrapper>
        <BackgroundColorWrapper>
            <BrowserRouter>
                <Switch>
                        <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
                        <Route path="/post" render={Post} />
                    <Route path="/rtl" render={(props) => <RTLLayout {...props} />} />
                        <Redirect from="/" to="/admin/Login" />
                </Switch>
            </BrowserRouter>
        </BackgroundColorWrapper>
        </ThemeContextWrapper>
    </ThemeProvider>,
    document.getElementById("root")
);